var _path, _path2, _path3, _path4, _rect;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheckNew(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 18,
    viewBox: "0 0 28 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.1193 12.241C23.5952 12.241 23.9809 11.8553 23.9809 11.3795C23.9809 10.9037 23.5952 10.5179 23.1193 10.5179C22.6435 10.5179 22.2578 10.9037 22.2578 11.3795C22.2578 11.8553 22.6435 12.241 23.1193 12.241Z",
    fill: "#6921C4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.8245 7.64636H4.15785C3.8463 7.64636 3.59375 7.96786 3.59375 8.36431C3.59375 8.76076 3.8463 9.08226 4.15785 9.08226H18.8245C19.1361 9.08226 19.3886 8.76076 19.3886 8.36431C19.3886 7.96786 19.1361 7.64636 18.8245 7.64636Z",
    fill: "#FF6019"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.13221 5.49229H7.36298C7.66037 5.49229 7.90144 5.1708 7.90144 4.77435C7.90144 4.37789 7.66037 4.0564 7.36298 4.0564H4.13221C3.83482 4.0564 3.59375 4.37789 3.59375 4.77435C3.59375 5.1708 3.83482 5.49229 4.13221 5.49229Z",
    fill: "#FF6019"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4.13221 12.2928H12.7694C13.0668 12.2928 13.3078 11.9713 13.3078 11.5749C13.3078 11.1784 13.0668 10.8569 12.7694 10.8569H4.13221C3.83482 10.8569 3.59375 11.1784 3.59375 11.5749C3.59375 11.9713 3.83482 12.2928 4.13221 12.2928Z",
    fill: "#FF6019"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 26,
    height: 15.3385,
    rx: 2.54751,
    stroke: "#6921C4",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckNew);
export default __webpack_public_path__ + "static/media/CheckNew.9a650670.svg";
export { ForwardRef as ReactComponent };